import { render, staticRenderFns } from "./ReadonlyInput.vue?vue&type=template&id=72380bb0&scoped=true&"
import script from "./ReadonlyInput.vue?vue&type=script&lang=js&"
export * from "./ReadonlyInput.vue?vue&type=script&lang=js&"
import style0 from "./ReadonlyInput.vue?vue&type=style&index=0&id=72380bb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72380bb0",
  null
  
)

export default component.exports